//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment';
//@end

//@import components
import SeparatorHorCommon from 'app_components/commons/separatorhor'
import SocialCommon from 'app_components/commons/social'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @INFO Import services
import EditorjsService from 'app_services/components/editorjs/editorjsService';
// @end

// @INFO Import Styles
import './../contentnewsCommon.scss'

// @ADD Component types
interface IContentnewsCommonLayoutProps {
  news: IPost | null
}

const ContentnewsCommonLayout: React.FC<IContentnewsCommonLayoutProps> = (props) => {

  const editorjsService = new EditorjsService()

  const [date, setDate] = useState<string>("")
  const { t } = useTranslation()

  useEffect(() => {
    if (props.news?.postDate) {
      setDate(moment.utc(props.news?.postDate).format('MM/DD/YYYY'))
    } else if (props.news?.eventDate) {
      setDate(moment.utc(props.news?.eventDate).format('MM/DD/YYYY'))
    }
  }, [props.news])


  return(
    <>
      {props.news && (
        <div className='content-news-item'>
          <div className={'news-item-title'}>
            {props.news.title}
          </div>
          {props.news.authors && Array.isArray(props.news.authors) && props.news.authors.length > 0 && (
            <div className={'news-item-author'}>
              Escrito por: {props.news.authors.join(', ')}
            </div>
          )}
          <div className={'news-item-date'}>
            {date}
          </div>
          <div className={'news-item-text'}>
            <div className="news-item-text-content">
            <img className='news-item-image' src={props.news.coverUrl} alt="imagen"/>
            <br />
            {/* <div className={'news-item-image'} style={{backgroundImage: `url(${props.news.coverUrl})`}}>
            </div> */}
            {props.news?.cover_caption && (
              <p className={'news-item-footer-image'}>Pie de foto: {props.news?.cover_caption}</p>
            )}
            <SeparatorHorCommon/>
            <br />
              {editorjsService.jsonToComponent(props.news?.content?.blocks ? props.news?.content?.blocks : [])}
            </div>
            {(props.news?.additional_info || props.news?.eventDate) && (
              <div className="additional-info">
                <p className="additional-info-title"><b>Datos del evento</b></p>
                {props.news?.eventDate && (
                  <p className="additional-info-item">Fecha: {moment(props.news?.eventDate).format('DD/MM/YYYY')}</p>
                )}
                {props.news?.additional_info?.country && (
                  <p className="additional-info-item">País organizador: {props.news?.additional_info?.country}</p>
                )}
                {props.news?.additional_info?.location && (
                  <p className="additional-info-item">Lugar: {props.news?.additional_info?.location}</p>
                )}
                {props.news?.additional_info?.schedule && (
                  <p className="additional-info-item">Hora (país organizador): {props.news?.additional_info?.schedule}</p>
                )}
                {props.news?.additional_info?.modality && (
                  <p className="additional-info-item">Modalidad: {props.news?.additional_info?.modality}</p>
                )}
                {props.news?.brochureUrl && (
                  <p>Folleto: <a href={props.news?.brochureUrl} target="__blank" rel="noopener noreferrer">Descarga aquí</a></p>
                )}
              </div>
            )}
          </div>
          <div
            style={{ marginBottom: '30px' }}
          >
            <SocialCommon/>
          </div>
        </div>

      )}
    </>
  )
}

export default ContentnewsCommonLayout
